import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IJobOrder } from 'app/models';

@Component({
  selector: 'app-job-order-form-component',
  templateUrl: './job-order-form.component.html',
  styleUrls: ['./job-order-form.component.scss'],
})
export class JobOrderFormComponent implements OnInit {
  static DIFFICULTY_MIN = 0;
  static DIFFICULTY_MAX = 10;

  @Output()
  save: EventEmitter<any> = new EventEmitter();

  @Output()
  cancel: EventEmitter<any> = new EventEmitter();

  formGroup = new FormGroup({
    id: new FormControl(null),
    code: new FormControl(''),
    deliveryDate: new FormControl(new Date()),
    nameByCustomer: new FormControl(''),
    description: new FormControl(''),
    difficulty: new FormControl('', [
      Validators.min(JobOrderFormComponent.DIFFICULTY_MIN),
      Validators.max(JobOrderFormComponent.DIFFICULTY_MAX),
      Validators.pattern('^[0-9]*$'),
    ]),
    customer: new FormControl(''),
    note: new FormControl(''),
  });

  constructor() {}

  @Input()
  set jobOrder(jobOrder: IJobOrder | undefined) {
    if (jobOrder) {
      this.formGroup.patchValue({
        id: jobOrder.id,
        code: jobOrder.code,
        deliveryDate: jobOrder.deliveryDate,
        nameByCustomer: jobOrder.nameByCustomer,
        description: jobOrder.description,
        difficulty: jobOrder.difficulty,
        customer: jobOrder.finalCustomer,
        note: jobOrder.note,
      });
    }
  }

  ngOnInit() {}

  onOkClicked() {
    this.save.emit(this.formGroup.value);
  }

  onCancelClicked() {
    this.cancel.emit();
  }
}
